/* eslint-disable id-blacklist */
interface String {
    trimEquals(value: string): boolean;
}

String.prototype.trimEquals = function(value: string): boolean {
    return this.trim().localeCompare(value?.trim()) === 0;
};
